import { createElement } from "react";
import { VerifiedBadge } from "./VerifiedBadge";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectLink(_ref) {
  let {
    icon,
    children,
    url,
    isVerified
  } = _ref;
  const Component = url ? "a" : "div";
  return children ? /*#__PURE__*/_jsxs("div", {
    className: "flex items-center gap-2",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/createElement(icon, {
        className: "w-4 h-4 text-grey-400"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex gap-2",
      children: [/*#__PURE__*/_jsx(Component, {
        href: url,
        target: "_blank",
        className: url && "text-blue-300 hover:underline",
        children: children
      }), isVerified && /*#__PURE__*/_jsx(VerifiedBadge, {})]
    })]
  }) : null;
}